import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { GIButton, Modal } from 'app-components';
import PaginatedTable, { renderCellContent } from '../../../components/common/table/PaginatedTable';

const StyledTextArea = styled.textarea<{}>`
    width: 100%;
    height: 45vh;
    padding: 10px;
    border-radius: 5px;
    resize: none;
    
    &:hover {
        background-color: #FFF !important;
    }
`;


export const SerffAttachmentsContent = ({ attachmentList }) => {
    const columns = [
        {
            key: 'documentName',
            label: 'Document Name',
            render: (item: any) => renderCellContent(item?.documentName, { width: '200px' }),
        },
        {
            key: 'documentSize',
            label: 'Size',
            render: (item: any) => renderCellContent(item?.documentSize),
        },
        {
            key: 'documentId',
            label: 'Download',
            render: (item: any) => {
                if (!item?.documentId) return null;

                const handleClick = () => {
                    const selectedDocumentId = item?.documentId;
                    if (selectedDocumentId) {
                        window.location.href = `/hix/admin/serff/downloadSerffTemplate?selectedDocumentId=${selectedDocumentId}`;
                    }
                };

                return (
                    <button type="submit" className="usa-button gi-button gi-button__outline" onClick={handleClick}>
                        Download
                    </button>
                );
            },
        },
    ];

    return (
        <PaginatedTable
            data={attachmentList}
            columns={columns}
            enableSorting={false}
            enableColumnHiding={false}
            hideItemCount={false}
            data-testid="serff_transfer_attachment_table"
        />
    );
};

export const SerffModalContent = ({ textContent, handleModalContent }) => {
    return (
        <StyledTextArea
            id="admin_serff_common_text_area"
            data-testid="admin_serff_common_text_area"
            value={textContent}
            onChange={e => handleModalContent(e.target.value)}
        />
    );
};

export const HandleModalContent = ({ modaltype, modalContent, handleModalContent }) =>
    modaltype === 'serffAttachments' ? (
        <div data-testid="serff_attachment_modal_content">
            <SerffAttachmentsContent attachmentList={modalContent} />
        </div>
    ) : (
        <div data-testid="serff_textarea_modal_content">
            <SerffModalContent textContent={modalContent} handleModalContent={handleModalContent} />
        </div>
    );

interface AdminSerffModalProps {
    modalTitleId: string;
    closeModal: () => void;
    content: ReactNode;
}

const AdminSerffModal: React.FC<AdminSerffModalProps> = ({
    modalTitleId = 'cap.admin.serff.modal.title',
    closeModal,
    content,
}) => {
    const onClose = () => {
        closeModal();
    };

    return (
        <Modal id="admin_serff_modal_detail" data-testid="admin_serff_modal">
            <Modal.Header
                id="admin_serff_modal_details_modal_title"
                titleId={modalTitleId}
                onHide={onClose}
                data-testid="admin_serff_modal_header"
            />
            <Modal.Body data-testid="admin_serff_modal_body">{content}</Modal.Body>
            <Modal.Controls>
                <GIButton
                    id="modalSubmitButton"
                    labelId="button.close"
                    variant="secondary"
                    onClickHandler={onClose}
                />
            </Modal.Controls>
        </Modal>
    );
};

export default AdminSerffModal;
